import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { InfoBannerData } from '@/components/InfoBanner';

export const useInfoBanner = () => {
  const [banners, setBanners] = useState<InfoBannerData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActiveBanners();
  }, []);

  const fetchActiveBanners = async () => {
    try {
      const { data, error } = await supabase
        .from('info_banner')
        .select('id, theme, content, link_url, link_text, is_dismissible, start_date, end_date')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) {
        console.error('Error fetching banners:', error);
        setBanners([]);
        return;
      }

      // Filter in JavaScript for date logic (more reliable)
      const nowDate = new Date();
      const filtered = (data || []).filter((banner: any) => {
        const startDate = banner.start_date ? new Date(banner.start_date) : null;
        const endDate = banner.end_date ? new Date(banner.end_date) : null;
        
        if (startDate && startDate > nowDate) return false;
        if (endDate && endDate < nowDate) return false;
        return true;
      });

      // Remove start_date and end_date from the response
      const banners = filtered.map(({ start_date, end_date, ...banner }: any) => banner);
      setBanners(banners as InfoBannerData[]);
    } catch (error) {
      console.error('Error fetching banners:', error);
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  return { banners, loading, refetch: fetchActiveBanners };
};

